export interface UserToNotify {
  id: string;
  name: string;
  email: string;
}

export interface OverviewCertificate {
  description: string;
  /** UTC Z */
  expiryDate: string | null;
  expireWarning: number;
  id: string;
  mandatory: boolean;
  numberOfUsers: number;
  typeId: string;
  usersToNotify: string[];
  usersToNotifyList: UserToNotify[];
}

export interface CompanyCertificateSettings {
  companyId: string;
  usersToNotify: string[];
  usersToNotifyList: UserToNotify[];
}

export interface CertificateType {
  id: string;
  companyId?: string;
  recVersion?: number;
  companyIds?: string[];
  typeId: string;
  description: string;
  mandatory: boolean;
  issuer?: string;
  issuerWebSite?: string;
  priority?: number;
  expireWarning: number;
  usersToNotify: string[];
  usersToNotifyList: UserToNotify[];
}

export interface UserCertificate {
  companyId: string;
  createdFromCompanyId: string;
  id: string;
  user: {
    companyProfileId: string;
    id: string;
    name: string;
  };
  typeGuid: string;
  typeId: string;
  /** UTC Z */
  issued: string | null;
  notes: string;
  /** UTC Z */
  validTo: string | null;
  numberOfDocuments: number;
  /** UTC Z */
  expiryNotificationDate: string | null;
  isEditable: boolean;
  lastUsedProjectName: string | null;
}

export type BatchUpdateUserCertificate = Pick<
  UserCertificate,
  'id' | 'typeId' | 'issued' | 'notes' | 'validTo' | 'expiryNotificationDate'
> & {
  userId: string;
};

export enum SortingField {
  Name,
  Type,
  Issued,
  ValidTo,
  Documents,
  Expiry,
  Notes,
}
